module.exports = __webpack_public_path__ + "img/hitachi-digital-host-4.4762dc8b.jpeg";